/**
 * AAA IDP terms reducer
 * Set the acceptance of terms for the user on the homepage
 * 
 */

import { ACCEPT_TERMS, DELETE } from '../../actions/types';
const initialState = {
  error: false,
  required: true,
  valid: null,
  value: false
};
export default function (state = initialState, action) {
  switch (action.type) {
    case ACCEPT_TERMS:
      {
        const {
          required
        } = state;
        const {
          value
        } = action;
        const valid = !value && required ? false : true;
        const acceptTerms = {
          error: !valid,
          required,
          valid,
          value
        };
        return acceptTerms;
      }
    case DELETE:
      return {
        error: false,
        required: true,
        valid: null,
        value: false
      };
    default:
      return state;
  }
}